"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabPickListDropdown = exports.SinglePickListDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _useOnClickOutside = require("../../utils/hooks/useOnClickOutside");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _Icon = _interopRequireDefault(require("../Icon"));
var _PickListDropdown = require("./PickListDropdown.style");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * 客製化下拉選單(多選)
 */

const PickListDropdown = _ref => {
  let {
    defaultTitle = "標題",
    value = [],
    options = [],
    onChange = () => {}
  } = _ref;
  const [isDropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  const [title, setTitle] = (0, _react.useState)("");
  const dropdownRef = (0, _react.useRef)();
  const intersection = (target, compare) => {
    const arrSet = new Set(compare);
    let isFirst = true;
    return target.map(item => {
      if (arrSet.has(item.value)) {
        const newItem = {
          ...item,
          checked: true
        };
        return newItem;
      }
      return item;
    });
  };
  const initOptions = data => {
    if (data.length === 0 || !data) return [];
    const nextData = data.map(item => {
      let checked = false;
      return {
        ...item,
        checked
      };
    });
    return intersection(nextData, value);
  };
  const newData = (0, _react.useMemo)(() => {
    return initOptions(options);
  }, [value, options]);
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, () => setDropdownOpen(false));
  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const checkboxChangeHandler = (e, list) => {
    const tmpOptions = [...newData];
    const isChecked = e.target.checked;
    const existItemIndex = tmpOptions.findIndex(item => item.value === list.value);
    tmpOptions[existItemIndex].checked = isChecked;
    const tmp = tmpOptions.filter(option => option.checked);
    if (tmpOptions.filter(option => option.checked === true).length === 1) {
      setTitle(tmp[0].name);
    }
    const checkedGroup = tmpOptions.filter(item => item.checked === true);
    onChange(checkedGroup.map(item => item.value));
  };
  const formateTitle = () => {
    const checkedOptions = newData.filter(item => item.checked === true);
    if (checkedOptions.length === 1) {
      return title || checkedOptions[0].name;
    } else if (checkedOptions.length > 1) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", null, title || checkedOptions[0].name), /*#__PURE__*/_react.default.createElement("span", {
        className: "others"
      }, checkedOptions.length - 1));
    }
  };
  const clearHandler = () => {
    const tmpData = [...newData];
    tmpData.map(item => {
      item.checked = false;
      return item;
    });
    onChange([]);
  };
  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, value.length > 0 ? formateTitle() : defaultTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap"
  }, options && newData.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiCheckList, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
      onChange: e => checkboxChangeHandler(e, item),
      checked: item.checked
    }, item.name));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "action"
  }, /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiClearButton, {
    disabled: value.length > 0 ? false : true,
    onClick: clearHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)), "\u6E05\u9664"))));
};
var _default = exports.default = PickListDropdown;
/**
 * 客製化下拉選單(單選)
 */
const SinglePickListDropdown = _ref2 => {
  var _options$filter$;
  let {
    defaultTitle = "defaultTitle",
    value,
    displayType = "value",
    clearable = false,
    options = [],
    onClick = () => {},
    onPickListClear = () => {}
  } = _ref2;
  const [isDropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  const [isHover, setHover] = (0, _react.useState)(false);
  const dropdownRef = (0, _react.useRef)();
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, () => setDropdownOpen(false));
  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const checkboxCheckHandler = checkList => {
    onClick(checkList.value, checkList.name);
    dropdownOpenHandler();
  };
  const onClear = event => {
    event.stopPropagation();
    onPickListClear();
  };
  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef,
    onMouseEnter: () => {
      setHover(true);
    },
    onMouseLeave: () => {
      setHover(false);
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, displayType === "value" ? value ? value : defaultTitle : value && options.length > 0 ? (_options$filter$ = options.filter(item => item.value === value)[0]) === null || _options$filter$ === void 0 ? void 0 : _options$filter$.name : defaultTitle), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, isHover && clearable ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    color: "#fff",
    onClick: event => onClear(event)
  }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap"
  }, options && options.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiCheckList, {
      key: index
    }, /*#__PURE__*/_react.default.createElement(_PickListDropdown.SingleList, {
      onClick: () => checkboxCheckHandler(item)
    }, item.name));
  }))));
};

/**
 * tab切換多選下拉選單
 */
exports.SinglePickListDropdown = SinglePickListDropdown;
const TabPickListDropdown = _ref3 => {
  let {
    defaultTitle = "題型",
    checkedList = {},
    options = [],
    onChange = () => {},
    onCheckAll = () => {}
  } = _ref3;
  const [isDropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  const dropdownRef = (0, _react.useRef)();
  (0, _useOnClickOutside.useOnClickOutside)(dropdownRef, () => setDropdownOpen(false));
  const dropdownOpenHandler = () => {
    setDropdownOpen(!isDropdownOpen);
  };
  const checkAll = (checked, val) => {
    const nextData = checked ? val.subMap.map(item => item.value) : [];
    onCheckAll(nextData, [val.value]);
  };
  const calAllCheckedCount = (0, _react.useMemo)(() => {
    let count = 0;
    if (Object.keys(checkedList).length === 0) return count;
    Object.entries(checkedList).forEach(_ref4 => {
      let [, value] = _ref4;
      value.forEach(() => {
        count++;
      });
    });
    return count;
  }, [Object.keys(checkedList).length]);
  return /*#__PURE__*/_react.default.createElement(_PickListDropdown.UiPickListDropdown, {
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "header",
    onClick: dropdownOpenHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, defaultTitle, calAllCheckedCount ? /*#__PURE__*/_react.default.createElement("span", {
    className: "others"
  }, calAllCheckedCount) : ""), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "expand_more",
    color: "#fff"
  }))), isDropdownOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "optionsWrap tabs"
  }, /*#__PURE__*/_react.default.createElement(_antd.Tabs, {
    defaultActiveKey: "1"
  }, options && options.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement(_antd.Tabs.TabPane, {
      tab: /*#__PURE__*/_react.default.createElement("div", {
        className: "tabHeader"
      }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox, {
        checked: checkedList[item.value] && checkedList[item.value].length === item.subMap.length,
        onChange: e => {
          checkAll(e.target.checked, item);
        }
      }), item.name, checkedList[item.value] ? /*#__PURE__*/_react.default.createElement("span", {
        className: "tabCheckCount"
      }, checkedList[item.value].length) : ""),
      key: item.value
    }, /*#__PURE__*/_react.default.createElement(_antd.Checkbox.Group, {
      value: checkedList[item.value] || [],
      options: item.subMap.map(optionItem => ({
        label: optionItem.name,
        value: optionItem.value
      })),
      onChange: val => {
        onChange && onChange(val, item.value);
      }
    }));
  })))));
};
exports.TabPickListDropdown = TabPickListDropdown;
PickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  value: _propTypes.default.array,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onChange: _propTypes.default.func
};
SinglePickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  value: _propTypes.default.any,
  clearable: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onClick: _propTypes.default.func,
  onPickListClear: _propTypes.default.func,
  displayType: _propTypes.default.string
};
TabPickListDropdown.propTypes = {
  defaultTitle: _propTypes.default.string,
  checkedList: _propTypes.default.object,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  onChange: _propTypes.default.func,
  onCheckAll: _propTypes.default.func
};